import { useAuth0 } from '@auth0/auth0-react';
import CommunicationService from 'Lib/API/Communication';
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from 'react';
import { toastr } from "react-redux-toastr";
import { AudienceTable } from './AudienceTable';
import { Wrapper } from './Theme';

export const Audience = ({setToggle}) => {
    const { getAccessTokenSilently } = useAuth0();
    const [page, setPage] = useState(0);
    const [audienceList,setAudienceList] = useState([])
    const [loading,setLoading] = useState(false)
    const [searchValue, setSearchValue] = React.useState("");
    const [count, setCount] = useState();
    const [refresh, setRefresh] = useState(false);

    const [sorting, setSorting] = useState({
        sort: {},
        search: undefined,
    });

    const getAudinceList = async ()=>{
        setLoading(true)
        try{
            const token = await getAccessTokenSilently();
            const result = await CommunicationService.getAudienceList(token , page + 1,30,sorting)
            setCount(result?.payload?.pagination?.count);
            setAudienceList([...result?.payload?.data]);
        }catch(err){
            toastr.error("Error", err?.data?.message);
        }finally{
            setLoading(false)
        }
    }
    useEffect(() => {
        if (searchValue === "" ) {
          setSorting({ ...sorting, search: undefined });
        } else {
          setSorting({ ...sorting, search: searchValue });
        }
      }, [searchValue]);
      
      const handleInputChange = (e) => {
        setPage(0);
        const inputValue = e.target.value;
        const regex = /[\\*\(\)\+]/;
        console.log('regex.test(inputValue)', regex.test(inputValue))
        if (!regex.test(inputValue)) {
          setSearchValue(inputValue);
        }
      };


      const debounceSearch = useCallback(
        debounce(() => {
          if (sorting?.search) {
            getAudinceList();
          }
        }, 500),
        [sorting?.search, page, refresh]
      );
    
      useEffect(() => {
        if (sorting?.search) {
          debounceSearch();
        } else {
          getAudinceList();
        }
        return () => debounceSearch.cancel();
      }, [sorting,page,refresh]);


      const handleSort = (name) => {
        setSorting((prev) => ({
          ...prev,
          sort: {
            [name]: prev.sort[name] === 1 ? -1 : 1,
          },
        }));
      };
    return (
        <Wrapper>
          
            <AudienceTable audienceList={audienceList} page={page} loading={loading} 
            searchValue={searchValue}
            setSearchValue={setSearchValue}
            handleInputChange={handleInputChange}
            setPage={setPage}
            setCount={setCount}
            count={count}
            handleSort={handleSort}
            refresh={refresh}
            setRefresh={setRefresh}
            setToggle={setToggle}
            />
        </Wrapper>
    );
};

